// src/api/authApi.js
import { getApi } from './axiosInstance';

// Fetch all old copies
export const getToken = async (userName, password) => {
    try {
        const response = await getApi().get('/Token', {
            params: {
                userName,
                password
            }
        });
        
        // The server returns { token: access_Token }
        if (!response.data || !response.data.token) {
            throw new Error('No token received from server');
        }
        
        return response.data.token;
    } catch (error) {
        console.error('Error logging in:', error);
        throw error;
    }
};

// Login function
export const login = async (userName, password) => {
    try {
        const response = await getApi().get('/Token', {
            params: { userName, password }
        });
        
        if (response.data && response.data.token) {
            return response.data.token;
        }
        throw new Error('No token received from server');
    } catch (error) {
        console.error('Login error:', error);
        throw error;
    }
};

// Logout function
export const logout = () => {
    // Token removal is handled by AuthContext
};